<script setup lang="js">
import { ref, onMounted, computed } from 'vue';
import { useRouteParams } from '@vueuse/router';
import { useAutoformStore } from '@/stores/autoform.store';
import { useProjectStore } from '@/stores/project.store';
import ModalTemplateSide from '@/components/modals/ModalTemplateSide.vue';
import useModal from '@/stores/modal.store';
import { storeToRefs } from 'pinia';

const autoformStore = useAutoformStore();
const projectStore = useProjectStore();
const { custom_variables, outputVariableList, selectedAutoCatalogIndex, autoCatalogs } =
  storeToRefs(autoformStore);
const { project } = storeToRefs(projectStore);
const { closeModal } = useModal();
const projectId = useRouteParams('projectId');

const variable = ref(null);
const input_catalog_id = ref(null);
const searchQueries = ref({});

const availableOutputEntities = computed(() => {
  return outputVariableList.value
    .filter((v) => v.name.includes('input_catalog'))
    .map((variable) => {
      const result = { ...variable };
      const match = variable.name.match(/^(?<entity>input_.+)\.(?<id>\d+)$/);

      if (match) {
        result.entity = match.groups.entity;
        result.id = match.groups.id;
      }

      return result;
    });
});

function createAutoCatalog() {
  let autoCatalog = {};
  autoCatalog.input_catalog_id = input_catalog_id.value;
  autoCatalog.variable = variable.value;

  if (selectedAutoCatalogIndex.value !== null && selectedAutoCatalogIndex.value !== undefined) {
    autoCatalogs.value[selectedAutoCatalogIndex.value] = autoCatalog;
  } else {
    autoCatalogs.value.push(autoCatalog);
  }

  closeModal();
}

onMounted(() => {
  if (!project.value.locales) {
    projectStore.getProject(projectId.value);
  }
  if (autoCatalogs.value[selectedAutoCatalogIndex.value]) {
    let autoCatalogClone = { ...autoCatalogs.value[selectedAutoCatalogIndex.value] };
    variable.value = autoCatalogClone.variable;
    input_catalog_id.value = autoCatalogClone.input_catalog_id;
  }
});
function filteredOptions(list, variable) {
  const query = searchQueries.value[variable]?.toLowerCase() || '';
  return list.filter(item =>
    item.title?.toLowerCase().includes(query)
  );
}
</script>

<template>
  <ModalTemplateSide @submit="createAutoCatalog">
    <template v-slot:title>Добавить автосправочник</template>
    <template v-slot:body>
      <div class="mt-3">
        <label class="form-label">Переменная</label>
        <input
          type="text"
          v-model="searchQueries['custom_variables']"
          placeholder="Поиск..."
          class="form-control mb-2"
        />
        <select v-model="variable" class="form-select">
          <template v-for="variable in filteredOptions(custom_variables, 'custom_variables')" :key="variable.name">
            <option v-if="variable.type === 'query'" :value="variable.name">
              {{ variable.title }}
            </option>
          </template>
        </select>
      </div>
      <div class="mt-3">
        <label class="form-label">Справочник (в исполняемой системе)</label>
        <input
          type="text"
          v-model="searchQueries['availableOutputEntities']"
          placeholder="Поиск..."
          class="form-control mb-2"
        />
        <select v-model="input_catalog_id" class="form-select">
          <template v-for="ent in filteredOptions(availableOutputEntities, 'availableOutputEntities')" :key="ent.id">
            <option :value="ent.id">
              {{ ent.title }}
            </option>
          </template>
        </select>
      </div>


    </template>
    <template v-slot:submit>Добавить</template>
  </ModalTemplateSide>
</template>
